<template>
  <section class="app-main" :class="{'hasViewsTag':needTagsView}">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapState({
      needTagsView: state => state.settings.tagsView
    }),
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>

.app-main {
  /*50 = navbar  */
  /*
  min-height: calc(100vh); // S06: FIXME calc(100vh - 50px);
  width: 100%;
  */
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1 1 auto;
}
.fixed-header+.app-main {
  padding-top: 54px;
}

.hasTagsView {

  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    /* min-height: calc(100vh - 84px); */
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
